
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetoshirdibushire() {



  const cardData =
  {
    keyword: ' Pune to Shirdi Bus Hire',
    heading: 'Vaishnavi Travels: Pune to Shirdi Bus Hire',
    headingDescription: 'Vaishnavi Travels provides dependable and budget-friendly Pune to Shirdi Bus Hire, ensuring a smooth and comfortable journey for pilgrims and group travelers. Our buses are well-maintained with spacious seating, powerful air-conditioning, and ample luggage space, making them ideal for religious yatras, family tours, and corporate group trips. With experienced drivers, punctual service, and flexible booking options, we guarantee a safe and hassle-free travel experience. Whether it’s a one-day darshan, weekend trip, or extended stay, Vaishnavi Travels offers reliable and convenient Pune to Shirdi bus rental services tailored to your needs',

    top: 'Top Places to Visit in Shirdi with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "Sai Baba Samadhi Mandir is the holiest shrine of Shirdi, attracting millions of devotees every year. The temple houses the sacred resting place of Shri Sai Baba, constructed in white marble and adorned with a silver throne. Devotees experience deep peace during the daily aartis and bhajans. The temple complex also hosts charitable activities and religious events. Standing in the darshan queue itself feels spiritually uplifting. Sai Baba Samadhi Mandir is Shirdi’s divine heart and the center of faith."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai is the sacred mosque where Sai Baba spent over 60 years of his life guiding devotees. It houses the dhuni (sacred fire) lit by Sai Baba, which continues to burn even today. The site symbolizes unity of faith, where both Hindus and Muslims worship together. Devotees believe the ash from the dhuni has healing powers. The atmosphere of simplicity and devotion makes Dwarkamai unique. Dwarkamai Masjid is Shirdi’s symbol of communal harmony and spiritual grace."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the small shrine where Sai Baba spent every alternate night during his later years. Today, it is a revered pilgrimage spot that preserves his bed, chair, and palki. Every Thursday, a grand procession of Sai Baba’s portrait and palki starts from Dwarkamai to Chavadi with music and prayers. This tradition keeps alive the devotional bond between Baba and his followers. The serene and sacred vibes here touch every visitor. Chavadi is Shirdi’s devotional heritage of love and remembrance."
  },
  {
    "title": "Sai Baba Museum (Shri Saibaba Sansthan Trust)",
    "description": "The Sai Baba Museum preserves personal belongings of Shri Sai Baba such as utensils, clothes, footwear, and coins. Managed by the Sai Baba Sansthan Trust, it offers an insight into his simple lifestyle and teachings. Photographs and artifacts narrate inspiring stories of his miracles and compassion. Pilgrims find it deeply emotional to witness these objects up close. The museum also educates children and devotees about Baba’s philosophy. It is Shirdi’s cultural and spiritual archive of Sai Baba’s legacy."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds special significance as it is the place where Sai Baba first entered Shirdi in 1858. The temple priest Mhalsapati warmly welcomed him by saying, 'Aao Sai,' giving him the name we all know today. Dedicated to Lord Khandoba, the temple attracts devotees seeking blessings for new beginnings. The simple architecture reflects its age-old charm. For Sai devotees, this temple is an emotional starting point of Baba’s journey in Shirdi. Khandoba Temple is Shirdi’s historic and spiritual gateway."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning 'place of the Guru,' is believed to be where Sai Baba was first seen meditating under a neem tree. A small shrine here houses an idol of Baba, a shivling, and portraits of saints. Devotees consider it highly sacred and light incense sticks for blessings. The neem tree is believed to have miraculous healing powers, and pilgrims take its leaves as prasad. The atmosphere here feels calm and meditative. Gurusthan is Shirdi’s spiritual spot of enlightenment and devotion."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is the beautiful garden where Sai Baba used to spend hours in meditation and watering plants. It also contains a lamp lit by Baba himself that still burns today. Shaded pathways, greenery, and peaceful surroundings make it a soothing spot for visitors. The garden reflects Baba’s love for nature and simplicity. Devotees find solace in walking through its serene environment. Lendi Baug is Shirdi’s spiritual garden of peace and reflection."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a theme park and museum that recreates important incidents from Sai Baba’s life. Life-size statues and models depict his miracles and daily activities with devotees. It is both educational and devotional, especially enjoyable for children and families. The lush surroundings add a picnic-like vibe to the visit. It gives a glimpse of Shirdi in Sai Baba’s time. Sai Heritage Village is Shirdi’s living tribute to Baba’s legacy and teachings."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park is a family-friendly attraction located close to Shirdi, offering fun and relaxation after spiritual visits. With wave pools, water slides, and adventure rides, it is loved by children and youngsters. The park also has food courts and rest areas, making it a complete day-out destination. Families often combine temple darshan with a trip here. It brings a balance of devotion and recreation. Wet N Joy is Shirdi’s joyful retreat for fun and leisure."
  },
  {
    "title": "Shani Shingnapur (Nearby)",
    "description": "Located about 70 km from Shirdi, Shani Shingnapur is a unique pilgrimage village dedicated to Lord Shani. The shrine is famous for its idol placed in an open-air platform with no roof. The village is renowned for houses without doors, symbolizing divine protection and faith. Devotees often combine Shirdi and Shani Shingnapur in the same trip. The spiritual energy here is strong and humbling. Shani Shingnapur is Shirdi’s most sacred outstation temple of unwavering devotion."
  }
],

"services": [
{
"name": "Pune to Shirdi AC Bus Rental",
"description": "Comfortable and air-conditioned bus rental service from Pune to Shirdi, designed to provide a pleasant and cool journey for pilgrims and tourists. These buses come equipped with reclining seats, ample legroom, and modern amenities, ensuring a relaxing trip. Ideal for families, corporate groups, and large gatherings planning a pilgrimage or leisure visit to Shirdi."
},
{
"name": "Shirdi Tour Bus from Pune",
"description": "Dedicated tour bus services from Pune to Shirdi that include convenient pickups, flexible itineraries, and on-time drop-offs. Our well-maintained buses accommodate various group sizes, offering both AC and non-AC options to suit your preferences and budget. Perfect for religious tours, family trips, and organized group travels."
},
{
"name": "Shirdi Darshan Bus Booking Pune",
"description": "Hassle-free Shirdi Darshan bus booking service from Pune, with easy online reservations and instant confirmations. Our buses are staffed by courteous drivers and come with GPS tracking to ensure timely arrival and departure. Ideal for pilgrims seeking a comfortable, reliable mode of transport for spiritual journeys."
},
{
"name": "Group Bus for Pune to Shirdi",
"description": "Spacious and reliable group bus rentals for trips from Pune to Shirdi, accommodating small to large groups. These buses are equipped to handle luggage and provide a smooth ride, making group travel convenient and enjoyable. Ideal for family outings, social clubs, and corporate pilgrimages."
},
{
"name": "Shirdi Outstation Bus Pune",
"description": "Specialized outstation bus services from Pune to Shirdi offering well-maintained vehicles suited for long-distance travel. We provide both AC and non-AC options with experienced drivers ensuring safety and punctuality. Perfect for pilgrimage tours and weekend getaways."
},
{
"name": "Non AC Bus to Shirdi Pune",
"description": "Affordable and efficient non-AC bus rental service for travel from Pune to Shirdi. These buses offer sturdy and comfortable seating, making them a budget-friendly option for families and groups on a pilgrimage or tour. Well-serviced and maintained for safe and reliable journeys."
},
{
"name": "Shirdi Temple Visit Bus Hire",
"description": "Specialized bus hire for visiting the Shirdi temple from Pune, focusing on convenience and ease of travel. These buses are ideal for devotees looking for direct transportation with flexible pick-up and drop-off points, ensuring timely arrival for darshan and smooth return journeys."
},
{
"name": "Pilgrimage Bus Pune to Shirdi",
"description": "Dedicated pilgrimage bus services from Pune to Shirdi, tailored to the spiritual traveler’s needs with comfortable seating, ample space for belongings, and serene travel ambiance. Our buses prioritize safety, cleanliness, and punctuality to enhance your pilgrimage experience."
},
{
"name": "Pune to Shirdi 50 Seater Bus",
"description": "Large-capacity 50-seater buses available for Pune to Shirdi trips, perfect for big groups and community pilgrimages. These buses provide comfortable seating, air conditioning options, and sufficient luggage space, ensuring group travel is efficient and pleasant."
},
{
"name": "45 Seater Shirdi Bus Booking",
"description": "Reliable 45-seater bus bookings from Pune to Shirdi offering a balance of spacious interiors and maneuverability. Suitable for medium to large groups, these buses include options for AC and non-AC variants, with professional drivers ensuring a safe journey."
},
{
"name": "Pune to Shirdi Tour Package Bus",
"description": "Comprehensive tour package buses from Pune to Shirdi, combining transportation with guided tours, stops at key points, and flexible schedules. These packages offer convenience for travelers wanting an organized pilgrimage or leisure trip, complete with comfortable travel amenities."
},
{
"name": "Book Shirdi Bus Online Pune",
"description": "User-friendly online booking platform for Shirdi bus rentals from Pune, providing instant quotes, secure payments, and customizable travel options. Choose from AC/non-AC, bus size, and pick-up timings for seamless trip planning with customer support available for assistance."
},
{
"name": "Shirdi Road Trip Bus from Pune",
"description": "Special road trip bus service from Pune to Shirdi designed for travelers who enjoy scenic routes and relaxed journeys. These buses feature comfortable seating, ample storage, and entertainment systems, making the trip to Shirdi enjoyable and memorable for families and groups."
}
],
"tableData": [
["Pune to Shirdi AC Bus Rental", "Shirdi Tour Bus from Pune"],
["Shirdi Darshan Bus Booking Pune", "Group Bus for Pune to Shirdi"],
["Shirdi Outstation Bus Pune", "Non AC Bus to Shirdi Pune"],
["Shirdi Temple Visit Bus Hire", "Pilgrimage Bus Pune to Shirdi"],
["Pune to Shirdi 50 Seater Bus", "45 Seater Shirdi Bus Booking"],
["Pune to Shirdi Tour Package Bus", "Book Shirdi Bus Online Pune"],
["Shirdi Road Trip Bus from Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Shirdi Bus Hire Service",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and affordable bus hire services from Pune to Shirdi, perfect for pilgrimage and group travel."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses provide ample legroom and comfortable seats to ensure a pleasant journey to Shirdi for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to maintain high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Pune to Shirdi Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your travel itinerary and group size."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Shirdi Route",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service with in-depth knowledge of the Pune to Shirdi route."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive pricing covering fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage Tours, Group Travel, and Events",
    "WhyChoosedescription": "Perfect for religious tours, corporate outings, family trips, and group travel from Pune to Shirdi."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock customer assistance to help with bookings and travel inquiries."
  }
]





















  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer bus hire services from Pune to Shirdi?',
      answer: 'Yes, Vaishnavi Travels provides reliable bus hire services from Pune to Shirdi, suitable for pilgrimages, group tours, and special events.',
    },
    {
      question: 'What types of buses are available for Pune to Shirdi trips?',
      answer: 'We offer a range of buses including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, to accommodate different group sizes and comfort preferences.',
    },
    {
      question: 'What is the approximate cost of hiring a bus from Pune to Shirdi?',
      answer: 'Rental rates depend on the bus type and trip duration, generally starting from ₹8,000 for a one-day trip for a 32 seater tempo traveller. We provide customized quotes based on your itinerary.',
    },
    {
      question: 'Are drivers included in the bus hire service?',
      answer: 'Yes, all our bus rentals include professional and experienced drivers who are familiar with the Pune-Shirdi route to ensure a safe and smooth journey.',
    },
    {
      question: 'Can the itinerary be customized for the Shirdi trip?',
      answer: 'Absolutely. We can tailor the schedule, stops, and timing according to your group’s preferences and darshan requirements.',
    },
    {
      question: 'How far in advance should I book a bus from Pune to Shirdi?',
      answer: 'Booking 3-5 days in advance is recommended, especially during peak pilgrimage seasons and weekends, to ensure availability.',
    },
    {
      question: 'Are additional charges like tolls and parking included in the fare?',
      answer: 'Tolls, parking fees, and driver allowances are typically extra and will be clearly communicated in your booking quote.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Ramesh Patil",
    position: "Pilgrimage Group Leader",
    feedback:
      "We booked a Pune to Shirdi bus through Vaishnavi Travels for our spiritual trip. The bus was clean, comfortable, and the driver was courteous and punctual. The overall experience was hassle-free and very satisfactory.",
    rating: 5,
  },
  {
    name: "Mrs. Sunita Deshmukh",
    position: "Family Organizer",
    feedback:
      "Vaishnavi Travels provided excellent service for our Pune to Shirdi pilgrimage. The AC bus was spacious and well-maintained. The driver ensured smooth travel and was very helpful with our group. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];




















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Bus Hire",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-shirdi-bus.jpg",
  "description": "Book Pune to Shirdi bus hire with Vaishnavi Travels for comfortable AC and Non AC buses perfect for group tours, pilgrimage trips, and temple visits.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.83",
    "ratingCount": "1620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2900",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-shirdi-bus-hire"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Shirdi Bus Hire | AC & Non AC Pilgrimage Bus | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Shirdi bus hire with Vaishnavi Travels for comfortable AC and Non AC buses perfect for group tours, pilgrimage trips, and temple visits."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi AC Bus Rental, Shirdi Tour Bus from Pune, Shirdi Darshan Bus Booking Pune, Group Bus for Pune to Shirdi, Shirdi Outstation Bus Pune, Non AC Bus to Shirdi Pune, Shirdi Temple Visit Bus Hire, Pilgrimage Bus Pune to Shirdi, Pune to Shirdi 50 Seater Bus, 45 Seater Shirdi Bus Booking, Pune to Shirdi Tour Package Bus, Book Shirdi Bus Online Pune, Shirdi Road Trip Bus from Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdibushire;